import { useStorage } from '@vueuse/core';

export default useStorage('historyHomeworkList', [] as number[]);
